<template>
  <div class="suggest-a-term">
    <a-icon
      title="Suggest a Term"
      class="suggest-a-term__icon"
      is-button
      :id="$options.consts.ACTIVATOR_ID.SUGGEST_A_TERM"
      aria-label="Suggest a Term"
      :icon="ICON.PLUS"
      :width="30"
      :height="30"
      :title-width="130"
      @click="openModal"
    />

    <a-modal-wrapper
      close-button
      :modal-name="MODAL.SUGGEST_A_TERM"
      :width="635"
      @close-modal="onCloseModal"
    >
      <a-suggest-a-term-form
        v-if="!isSuccessMessageVisible"
        :term-id="termId"
        :term-name="termName"
        :edit-mode-initially="isEditTermSuggestion"
        @submit-form="onSuggestATerm"
      />

      <a-success-message
        v-else
        title="Thank you!"
        text="Your submission is under review"
        :icon="ICON.THUMB_UP"
      >
        <a-button
          class="suggest-a-term__add-another"
          @click="onAddAnotherSuggestion"
        >
          Add another
        </a-button>
      </a-success-message>
    </a-modal-wrapper>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AModalWrapper, { MODAL } from '@/components/_modals/AModalWrapper'
import AIcon, { ICON } from 'shared/AIcon'
import {
  ACTIVATOR_ID,
  ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID
} from 'enums/activator-id'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'ASuggestATerm',
  components: {
    AIcon,
    AModalWrapper,
    ASuggestATermForm: hydrateWhenVisible(() => import('./ASuggestATermForm'), {
      props: ['term-id', 'term-name', 'edit-mode-initially']
    }),
    ASuccessMessage: hydrateWhenVisible(
      () => import('shared/ASuccessMessage'),
      { props: ['title', 'text', 'icon'] }
    )
  },
  props: {
    termId: propValidator([PROP_TYPES.STRING], false),
    termName: propValidator([PROP_TYPES.STRING], false)
  },
  consts: {
    resetComponentDataFields: [
      'isSuccessMessageVisible',
      'isEditTermSuggestion',
      'timeoutId'
    ],
    ACTIVATOR_ID
  },
  data() {
    return {
      ICON,
      MODAL,
      isSuccessMessageVisible: false,
      isEditTermSuggestion: !!this.termId,
      timeoutId: null
    }
  },
  methods: {
    openModal() {
      this.$helper.openModal(MODAL.SUGGEST_A_TERM, {
        activatorSelector:
          ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID[ACTIVATOR_ID.SUGGEST_A_TERM]
      })
    },
    onCloseModal() {
      clearTimeout(this.timeoutId)
      this.$helper.resetComponentData(
        this,
        this.$options.consts.resetComponentDataFields
      )
    },
    async onSuggestATerm() {
      this.isSuccessMessageVisible = true
      this.timeoutId = this.$helper.closeModal(MODAL.SUGGEST_A_TERM, 5000)
    },
    onAddAnotherSuggestion() {
      this.isSuccessMessageVisible = false
      this.isEditTermSuggestion = false
      clearTimeout(this.timeoutId)
    }
  }
}
</script>

<style lang="scss" scoped>
.suggest-a-term {
  display: flex;
  align-items: center;

  .suggest-a-term__icon {
    flex-direction: row;

    /deep/ .a-icon__description::before {
      font-size: 16px;

      font-weight: bold;
      margin-left: 5px;
      white-space: nowrap;
    }
  }

  &__add-another {
    margin: 40px auto 0 auto;
  }
}
</style>
